import { render } from "./SettingApi.vue?vue&type=template&id=3efced72&scoped=true"
import script from "./SettingApi.vue?vue&type=script&lang=js"
export * from "./SettingApi.vue?vue&type=script&lang=js"

import "./SettingApi.vue?vue&type=style&index=0&id=3efced72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efced72"]])

export default __exports__